import { usageTrackEvent } from "../functions/telemetry";

const trackEventCx = (
  name: string,
  context: {
    relatedFeature: number;
    isMetricsTracking?: boolean;
    metadata?: any;
  },
) => {
  usageTrackEvent(name, context);
};

export default trackEventCx;
